import { connect } from 'react-redux';
import UnidadesRecebiveis from './unidadesRecebiveis';

export default connect()(UnidadesRecebiveis);
